import FooterToggleButton from './footer-toggle-button';
import FooterContentButton from './footer-content-button';
import FooterBar from './footerbar';

export { FooterToggleButton, FooterContentButton, FooterBar };

export default {
  FooterToggleButton: FooterToggleButton,
  FooterContentButton: FooterContentButton,
  FooterBar: FooterBar
};